<section class="container pt-2">
  <div class="row">
    <div class="col-md-8 offset-lg-1 pb-5 mb-2 mb-lg-4 pt-md-5 mt-n3 mt-md-0 text-center">
      <h3 class="page-not-found__title">Page Not Found</h3>

      @if (isAuthenticated()) {
        <!-- Signed-in member: a dead URL is a stale/mistyped link, so route them
             back into the app rather than leaving the support mailto as the only
             way out (#1441). -->
        <p>That page has moved or no longer exists. Here is where to go next:</p>
        <div class="page-not-found__actions">
          <a [routerLink]="dashboardLink()" class="btn btn-primary page-not-found__cta">Back to dashboard</a>
          <a [routerLink]="browseLink()" class="btn btn-outline-primary page-not-found__cta">Browse the calendar</a>
        </div>
        <p class="page-not-found__support">
          Still stuck? Contact
          <a href="mailto:support@appliedbiox.com">support&#64;appliedbiox.com</a>.
        </p>
      } @else {
        <p>
          If you require assistance, please contact
          <a href="mailto:support@appliedbiox.com">support&#64;appliedbiox.com</a>.
        </p>
      }
    </div>
  </div>
</section>
